import { useContext } from 'react'
import { ThemeContext } from '../../context/theme-context/ThemeContext'
import LightMode from '@mui/icons-material/LightMode'
import DarkMode from '@mui/icons-material/DarkMode'
import styles from './styles.module.css'

function ThemeToggle() {
  const { theme, toggleTheme } = useContext(ThemeContext)

  return (
    <div className={styles.toggleContainer}>
      <button
        className={styles.toggleButton}
        onClick={toggleTheme}
        aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        title={theme === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
      >
        <span className={styles.icon}>
          {theme === 'light' ? <DarkMode /> : <LightMode />}
        </span>
      </button>
    </div>
  )
}

export default ThemeToggle
